module.exports = __webpack_public_path__ + "img/boomkitty.4c76ea76.jpg";